import { createTranslations } from '../../i18n/types';

const en = {
  wiki: 'Wiki',
  homeH1: 'CS2 Skin Wiki',
  homeSubtitle: 'Every CS2 skin: wear, rarity, cases and collections',
  categoriesTitle: 'Categories',
  featuredTitle: 'Skins explained',
  allWeaponsTitle: 'All weapons',
  aboutWiki: 'About the wiki',
  readMore: 'Read more',
  showAll: 'Show all {{count}}',
  floatScaleLabel: 'Float scale from 0 to 1 and the exterior for each range',
  searchPlaceholder: 'Find a skin, weapon or case',
  searchPlaceholderShort: 'Skin, weapon or case',
  searchSubmit: 'Search',
  searchClear: 'Clear search',
  searchH1: 'Search the wiki',
  searchResultsFor: 'Results for “{{q}}”',
  searchEmptyTitle: 'Nothing found',
  searchEmptyText: 'Check the spelling or try the English name.',
  searchEmptyTextLatin: 'Check the spelling or shorten the query.',
  searchOpenCatalog: 'Open the catalog',
  searchErrorTitle: 'Search didn’t load',
  searchErrorText: 'Check your connection and search again.',
  searchShortQuery: 'Type at least two characters.',
  retry: 'Try again',
  suggestEmpty: 'No matches',
  suggestAll: 'Show all results',
  typeSkin: 'Skin',
  typeWeapon: 'Weapon',
  typeContainer: 'Case',
  typeCollection: 'Collection',
  catPistols: 'Pistols',
  catRifles: 'Rifles',
  catSmgs: 'SMGs',
  catHeavy: 'Heavy',
  catKnives: 'Knives',
  catGloves: 'Gloves',
  catEquipment: 'Equipment',
  weaponsTitle: 'Weapons',
  selectionsTitle: 'Selections',
  guidesTitle: 'Guides',
  containersTitle: 'Latest cases',
  allSkins: 'All skins',
  allGuides: 'All guides',
  allSelections: 'All selections',
  allCases: 'All cases',
  allCollections: 'All collections',
  skinsOne: '{{count}} skin',
  skinsFew: '{{count}} skins',
  skinsMany: '{{count}} skins',
  knivesOne: '{{count}} knife',
  knivesFew: '{{count}} knives',
  knivesMany: '{{count}} knives',
  glovesOne: '{{count}} pair of gloves',
  glovesFew: '{{count}} pairs of gloves',
  glovesMany: '{{count}} pairs of gloves',
  rareItemsOne: '{{count}} item',
  rareItemsFew: '{{count}} items',
  rareItemsMany: '{{count}} items',
  skinsPlusRare: '{{skins}} + {{rare}}',
  catalogH1: 'CS2 skins',
  catalogCategoryH1: 'CS2 skins: {{category}}',
  filtersTitle: 'Filters',
  filterWeapon: 'Weapon',
  filterRarity: 'Rarity',
  filterCollection: 'Collection',
  filterCase: 'Case',
  filterExterior: 'Exterior',
  filterStatTrak: 'Has StatTrak™',
  filterSouvenir: 'Has Souvenir',
  anyWeapon: 'Any weapon',
  anyRarity: 'Any rarity',
  anyCollection: 'Any collection',
  anyCase: 'Any case',
  removeFilter: 'Remove filter “{{name}}”',
  sortLabel: 'Sort',
  sortRarity: 'By rarity',
  sortName: 'By name',
  sortRelease: 'Newest first',
  sortPrice: 'By price',
  applyFilters: 'Show',
  resetFilters: 'Reset filters',
  catalogEmptyTitle: 'No skins match these filters',
  catalogEmptyText: 'Remove some filters or reset them all.',
  prevPage: 'Previous',
  nextPage: 'Next',
  pageOf: 'Page {{page}} of {{count}}',
  foundCount: 'Found: {{count}}',
  foundCountMasculine: 'Found: {{count}}',
  priceFrom: 'from {{price}}',
  weaponAllFilters: 'All filters in the catalog',
  breadcrumbs: 'Breadcrumbs',
  exteriorFn: 'Factory New',
  exteriorMw: 'Minimal Wear',
  exteriorFt: 'Field-Tested',
  exteriorWw: 'Well-Worn',
  exteriorBs: 'Battle-Scarred',
  kindNormal: 'Normal',
  kindStatTrak: 'StatTrak™',
  kindSouvenir: 'Souvenir',
  vanillaFinish: 'Vanilla',
  phasesTitle: 'Phases',
  statsTitle: 'Details',
  statWeapon: 'Weapon',
  statFinish: 'Finish',
  statRarity: 'Rarity',
  statFloat: 'Float range',
  statExteriors: 'Exteriors',
  statKinds: 'Versions',
  statCollections: 'Collection',
  statContainers: 'Cases',
  statRelease: 'Release year',
  rareItem: 'rare special item',
  rareDropNote: 'Drops as a rare special item ★',
  pricesTitle: 'Steam prices',
  pricesHint: 'Steam Community Market price in US dollars.',
  priceAsOf: 'Updated {{date}}.',
  noPrice: 'No current data',
  noPriceMarked: 'No current data for the marked versions',
  gameDescriptionTitle: 'In-game description',
  faqTitle: 'FAQ',
  similarTitle: 'Similar skins',
  shotTitle: 'Available on SHOT',
  shotHint: 'This skin is in these SHOT cases.',
  englishName: 'English name',
  caseReleased: 'Released in {{year}}',
  rareTitle: 'Rare special items',
  compositionTitle: 'Skins inside',
  rareHintKnives: 'Knives drop from this case as a separate rare special item.',
  rareHintGloves: 'Gloves drop from this case as a separate rare special item.',
  rareHintKnivesAndGloves: 'Knives and gloves drop from this case as a separate rare special item.',
  rareKnives: 'knives',
  rareGloves: 'gloves',
  rareKnivesAndGloves: 'knives and gloves',
  caseCollectionTitle: 'Case collection',
  collectionCasesTitle: 'Cases with this collection',
  collectionReleased: 'Released in {{year}}',
  tocTitle: 'Contents',
  reviewedOn: 'Reviewed {{date}}',
  reviewedBy: 'Reviewed by the SHOT team · {{date}}',
  shortAnswer: 'Short answer',
  guidesH1: 'CS2 skin guides',
  selectionsH1: 'CS2 skin selections',
  casesH1: 'CS2 cases',
  collectionsH1: 'CS2 collections',
  weaponSkinsH1: '{{weapon}} skins',
};

export default createTranslations({
  en,
  ru: {
    wiki: 'Вики',
    homeH1: 'Вики скинов CS2',
    homeSubtitle: 'Все скины CS2: износ, редкость, кейсы и коллекции',
    categoriesTitle: 'Категории',
    featuredTitle: 'Скины с разбором',
    allWeaponsTitle: 'Всё оружие',
    aboutWiki: 'О вики',
    readMore: 'Читать полностью',
    showAll: 'Показать все {{count}}',
    floatScaleLabel: 'Шкала float от 0 до 1 и состояние износа на каждом отрезке',
    searchPlaceholder: 'Найти скин, оружие или кейс',
    searchPlaceholderShort: 'Скин, оружие или кейс',
    searchSubmit: 'Найти',
    searchClear: 'Очистить запрос',
    searchH1: 'Поиск по вики',
    searchResultsFor: 'Результаты по запросу «{{q}}»',
    searchEmptyTitle: 'Ничего не нашли',
    searchEmptyText: 'Проверь написание или попробуй название на английском.',
    searchEmptyTextLatin: 'Проверь написание или сократи запрос.',
    searchOpenCatalog: 'Открыть каталог',
    searchErrorTitle: 'Поиск не загрузился',
    searchErrorText: 'Проверь соединение и повтори поиск.',
    searchShortQuery: 'Напиши хотя бы два символа.',
    retry: 'Повторить',
    suggestEmpty: 'Нет совпадений',
    suggestAll: 'Показать все результаты',
    typeSkin: 'Скин',
    typeWeapon: 'Оружие',
    typeContainer: 'Кейс',
    typeCollection: 'Коллекция',
    catPistols: 'Пистолеты',
    catRifles: 'Винтовки',
    catSmgs: 'Пистолеты-пулемёты',
    catHeavy: 'Тяжёлое оружие',
    catKnives: 'Ножи',
    catGloves: 'Перчатки',
    catEquipment: 'Снаряжение',
    weaponsTitle: 'Оружие',
    selectionsTitle: 'Подборки',
    guidesTitle: 'Руководства',
    containersTitle: 'Свежие кейсы',
    allSkins: 'Все скины',
    allGuides: 'Все руководства',
    allSelections: 'Все подборки',
    allCases: 'Все кейсы',
    allCollections: 'Все коллекции',
    skinsOne: '{{count}} скин',
    skinsFew: '{{count}} скина',
    skinsMany: '{{count}} скинов',
    knivesOne: '{{count}} нож',
    knivesFew: '{{count}} ножа',
    knivesMany: '{{count}} ножей',
    glovesOne: '{{count}} пара перчаток',
    glovesFew: '{{count}} пары перчаток',
    glovesMany: '{{count}} пар перчаток',
    rareItemsOne: '{{count}} предмет',
    rareItemsFew: '{{count}} предмета',
    rareItemsMany: '{{count}} предметов',
    skinsPlusRare: '{{skins}} + {{rare}}',
    catalogH1: 'Скины CS2',
    catalogCategoryH1: 'Скины CS2: {{category}}',
    filtersTitle: 'Фильтры',
    filterWeapon: 'Оружие',
    filterRarity: 'Редкость',
    filterCollection: 'Коллекция',
    filterCase: 'Кейс',
    filterExterior: 'Износ',
    filterStatTrak: 'Есть StatTrak™',
    filterSouvenir: 'Есть сувенирная версия',
    anyWeapon: 'Любое оружие',
    anyRarity: 'Любая редкость',
    anyCollection: 'Любая коллекция',
    anyCase: 'Любой кейс',
    removeFilter: 'Убрать фильтр «{{name}}»',
    sortLabel: 'Сортировка',
    sortRarity: 'По редкости',
    sortName: 'По названию',
    sortRelease: 'Сначала новые',
    sortPrice: 'По цене',
    applyFilters: 'Показать',
    resetFilters: 'Сбросить фильтры',
    catalogEmptyTitle: 'Под эти фильтры скинов нет',
    catalogEmptyText: 'Убери часть фильтров или сбрось их все.',
    prevPage: 'Назад',
    nextPage: 'Дальше',
    pageOf: 'Страница {{page}} из {{count}}',
    foundCount: 'Найдено: {{count}}',
    foundCountMasculine: 'Найдено: {{count}}',
    priceFrom: 'от {{price}}',
    weaponAllFilters: 'Все фильтры в каталоге',
    breadcrumbs: 'Навигационная цепочка',
    exteriorFn: 'Прямо с завода',
    exteriorMw: 'Немного поношенное',
    exteriorFt: 'После полевых испытаний',
    exteriorWw: 'Поношенное',
    exteriorBs: 'Закалённое в боях',
    kindNormal: 'Обычный',
    kindStatTrak: 'StatTrak™',
    kindSouvenir: 'Сувенирный',
    vanillaFinish: 'Без раскраски',
    phasesTitle: 'Фазы',
    statsTitle: 'Характеристики',
    statWeapon: 'Оружие',
    statFinish: 'Отделка',
    statRarity: 'Редкость',
    statFloat: 'Диапазон float',
    statExteriors: 'Износ',
    statKinds: 'Версии',
    statCollections: 'Коллекция',
    statContainers: 'Кейсы',
    statRelease: 'Год выхода',
    rareItem: 'редкий предмет',
    rareDropNote: 'Выпадает как редкий предмет ★',
    pricesTitle: 'Цены в Steam',
    pricesHint: 'Цена на торговой площадке Steam в долларах США.',
    priceAsOf: 'Обновлено {{date}}',
    noPrice: 'Нет актуальных данных',
    noPriceMarked: 'Нет актуальных данных по отмеченным вариантам',
    gameDescriptionTitle: 'Описание из игры',
    faqTitle: 'Частые вопросы',
    similarTitle: 'Похожие скины',
    shotTitle: 'Доступно в SHOT',
    shotHint: 'Этот скин есть в составе кейсов SHOT.',
    englishName: 'Английское название',
    caseReleased: 'Вышел в {{year}} году',
    rareTitle: 'Редкие предметы',
    compositionTitle: 'Состав',
    rareHintKnives: 'Ножи выпадают из этого кейса как отдельный редкий предмет.',
    rareHintGloves: 'Перчатки выпадают из этого кейса как отдельный редкий предмет.',
    rareHintKnivesAndGloves: 'Ножи и перчатки выпадают из этого кейса как отдельный редкий предмет.',
    rareKnives: 'ножи',
    rareGloves: 'перчатки',
    rareKnivesAndGloves: 'ножи и перчатки',
    caseCollectionTitle: 'Коллекция кейса',
    collectionCasesTitle: 'Кейсы с этой коллекцией',
    collectionReleased: 'Вышла в {{year}} году',
    tocTitle: 'Содержание',
    reviewedOn: 'Проверено {{date}}',
    reviewedBy: 'Проверено редакцией SHOT · {{date}}',
    shortAnswer: 'Коротко',
    guidesH1: 'Руководства по скинам CS2',
    selectionsH1: 'Подборки скинов CS2',
    casesH1: 'Кейсы CS2',
    collectionsH1: 'Коллекции CS2',
    weaponSkinsH1: 'Скины {{weapon}}',
  },
  uz: {
    wiki: 'Viki',
    homeH1: 'CS2 skinlari vikisi',
    homeSubtitle: 'CS2 ning barcha skinlari: eskirish, kamyoblik, keys va kolleksiyalar',
    categoriesTitle: 'Toifalar',
    featuredTitle: 'Tahlil qilingan skinlar',
    allWeaponsTitle: 'Barcha qurollar',
    aboutWiki: 'Viki haqida',
    readMore: 'Toʻliq oʻqish',
    showAll: 'Hammasini koʻrsatish ({{count}})',
    floatScaleLabel: 'Float shkalasi 0 dan 1 gacha va har bir boʻlakdagi eskirish holati',
    searchPlaceholder: 'Skin, qurol yoki keysni qidir',
    searchPlaceholderShort: 'Skin, qurol yoki keys',
    searchSubmit: 'Qidirish',
    searchClear: 'Soʻrovni tozalash',
    searchH1: 'Viki boʻyicha qidiruv',
    searchResultsFor: '«{{q}}» boʻyicha natijalar',
    searchEmptyTitle: 'Hech narsa topilmadi',
    searchEmptyText: 'Yozilishini tekshir yoki nomini inglizcha yozib koʻr.',
    searchEmptyTextLatin: 'Yozilishini tekshir yoki soʻrovni qisqartir.',
    searchOpenCatalog: 'Katalogni ochish',
    searchErrorTitle: 'Qidiruv yuklanmadi',
    searchErrorText: 'Internetni tekshirib, qidiruvni takrorla.',
    searchShortQuery: 'Kamida ikkita belgi yoz.',
    retry: 'Qayta urinish',
    suggestEmpty: 'Mos natija yoʻq',
    suggestAll: 'Barcha natijalarni koʻrsatish',
    typeSkin: 'Skin',
    typeWeapon: 'Qurol',
    typeContainer: 'Keys',
    typeCollection: 'Kolleksiya',
    catPistols: 'Toʻpponchalar',
    catRifles: 'Miltiqlar',
    catSmgs: 'Pistolet-pulemyotlar',
    catHeavy: 'Ogʻir qurollar',
    catKnives: 'Pichoqlar',
    catGloves: 'Qoʻlqoplar',
    catEquipment: 'Jihozlar',
    weaponsTitle: 'Qurollar',
    selectionsTitle: 'Toʻplamlar',
    guidesTitle: 'Qoʻllanmalar',
    containersTitle: 'Yangi keyslar',
    allSkins: 'Barcha skinlar',
    allGuides: 'Barcha qoʻllanmalar',
    allSelections: 'Barcha toʻplamlar',
    allCases: 'Barcha keyslar',
    allCollections: 'Barcha kolleksiyalar',
    skinsOne: '{{count}} ta skin',
    skinsFew: '{{count}} ta skin',
    skinsMany: '{{count}} ta skin',
    knivesOne: '{{count}} ta pichoq',
    knivesFew: '{{count}} ta pichoq',
    knivesMany: '{{count}} ta pichoq',
    glovesOne: '{{count}} juft qoʻlqop',
    glovesFew: '{{count}} juft qoʻlqop',
    glovesMany: '{{count}} juft qoʻlqop',
    rareItemsOne: '{{count}} ta buyum',
    rareItemsFew: '{{count}} ta buyum',
    rareItemsMany: '{{count}} ta buyum',
    skinsPlusRare: '{{skins}} + {{rare}}',
    catalogH1: 'CS2 skinlari',
    catalogCategoryH1: 'CS2 skinlari: {{category}}',
    filtersTitle: 'Filtrlar',
    filterWeapon: 'Qurol',
    filterRarity: 'Kamyoblik',
    filterCollection: 'Kolleksiya',
    filterCase: 'Keys',
    filterExterior: 'Eskirish',
    filterStatTrak: 'StatTrak™ versiyasi bor',
    filterSouvenir: 'Souvenir versiyasi bor',
    anyWeapon: 'Har qanday qurol',
    anyRarity: 'Istalgan kamyoblik',
    anyCollection: 'Har qanday kolleksiya',
    anyCase: 'Har qanday keys',
    removeFilter: '«{{name}}» filtrini olib tashlash',
    sortLabel: 'Saralash',
    sortRarity: 'Kamyobligi boʻyicha',
    sortName: 'Nomi boʻyicha',
    sortRelease: 'Avval yangilari',
    sortPrice: 'Narxi boʻyicha',
    applyFilters: 'Koʻrsatish',
    resetFilters: 'Filtrlarni tozalash',
    catalogEmptyTitle: 'Bu filtrlarga mos skin yoʻq',
    catalogEmptyText: 'Filtrlarning bir qismini olib tashla yoki hammasini tozala.',
    prevPage: 'Orqaga',
    nextPage: 'Keyingi',
    pageOf: '{{page}}-sahifa, jami {{count}}',
    foundCount: 'Topildi: {{count}}',
    foundCountMasculine: 'Topildi: {{count}}',
    priceFrom: '{{price}} dan',
    weaponAllFilters: 'Katalogdagi barcha filtrlar',
    breadcrumbs: 'Sahifa yoʻli',
    exteriorFn: 'Zavod yangi',
    exteriorMw: 'Minimal eskirgan',
    exteriorFt: 'Maydonda sinovdan oʻtgan',
    exteriorWw: 'Yaxshi eskirgan',
    exteriorBs: 'Jangda zararlangan',
    kindNormal: 'Oddiy',
    kindStatTrak: 'StatTrak™',
    kindSouvenir: 'Souvenir',
    vanillaFinish: 'Boʻyoqsiz',
    phasesTitle: 'Fazalar',
    statsTitle: 'Xususiyatlar',
    statWeapon: 'Qurol',
    statFinish: 'Bezak',
    statRarity: 'Kamyoblik',
    statFloat: 'Float oraligʻi',
    statExteriors: 'Eskirish',
    statKinds: 'Versiyalar',
    statCollections: 'Kolleksiya',
    statContainers: 'Keyslar',
    statRelease: 'Chiqqan yili',
    rareItem: 'nodir buyum',
    rareDropNote: 'Nodir buyum sifatida tushadi ★',
    pricesTitle: 'Steamʼdagi narxlar',
    pricesHint: 'Steam savdo maydonchasidagi narx, AQSh dollarida.',
    priceAsOf: '{{date}} holatiga.',
    noPrice: 'Dolzarb maʼlumot yoʻq',
    noPriceMarked: 'Belgilangan variantlar boʻyicha dolzarb maʼlumot yoʻq',
    gameDescriptionTitle: 'Oʻyindagi tavsif',
    faqTitle: 'Koʻp beriladigan savollar',
    similarTitle: 'Oʻxshash skinlar',
    shotTitle: 'SHOTʼda bor',
    shotHint: 'Bu skin quyidagi SHOT keyslari tarkibida bor.',
    englishName: 'Inglizcha nomi',
    caseReleased: '{{year}}-yilda chiqqan',
    rareTitle: 'Nodir buyumlar',
    compositionTitle: 'Tarkibi',
    rareHintKnives: 'Pichoqlar bu keysdan alohida nodir buyum sifatida tushadi.',
    rareHintGloves: 'Qoʻlqoplar bu keysdan alohida nodir buyum sifatida tushadi.',
    rareHintKnivesAndGloves: 'Pichoq va qoʻlqoplar bu keysdan alohida nodir buyum sifatida tushadi.',
    rareKnives: 'pichoqlar',
    rareGloves: 'qoʻlqoplar',
    rareKnivesAndGloves: 'pichoq va qoʻlqoplar',
    caseCollectionTitle: 'Keys kolleksiyasi',
    collectionCasesTitle: 'Shu kolleksiya tushadigan keyslar',
    collectionReleased: '{{year}}-yilda chiqqan',
    tocTitle: 'Mundarija',
    reviewedOn: '{{date}}da tekshirilgan',
    reviewedBy: 'SHOT tahririyati tekshirgan · {{date}}',
    shortAnswer: 'Qisqacha',
    guidesH1: 'CS2 skinlari boʻyicha qoʻllanmalar',
    selectionsH1: 'CS2 skinlari toʻplamlari',
    casesH1: 'CS2 keyslari',
    collectionsH1: 'CS2 kolleksiyalari',
    weaponSkinsH1: '{{weapon}} skinlari',
  },
  // WHY: вики на фарси не открывается (/fa/wiki → 404), блок нужен только ради типа словаря
  fa: en,
  pt: {
    wiki: 'Wiki',
    homeH1: 'Wiki de skins do CS2',
    homeSubtitle: 'Todas as skins do CS2: desgaste, raridade, caixas e coleções',
    categoriesTitle: 'Categorias',
    featuredTitle: 'Skins com análise',
    allWeaponsTitle: 'Todas as armas',
    aboutWiki: 'Sobre a wiki',
    readMore: 'Ler tudo',
    showAll: 'Mostrar todas ({{count}})',
    floatScaleLabel: 'Escala de float de 0 a 1 e o estado de cada faixa',
    searchPlaceholder: 'Busque skin, arma ou caixa',
    searchPlaceholderShort: 'Skin, arma ou caixa',
    searchSubmit: 'Buscar',
    searchClear: 'Limpar busca',
    searchH1: 'Buscar na wiki',
    searchResultsFor: 'Resultados para “{{q}}”',
    searchEmptyTitle: 'Nada encontrado',
    searchEmptyText: 'Confira a grafia ou tente o nome em inglês.',
    searchEmptyTextLatin: 'Confira a grafia ou encurte a busca.',
    searchOpenCatalog: 'Abrir o catálogo',
    searchErrorTitle: 'A busca não carregou',
    searchErrorText: 'Verifique a conexão e repita a busca.',
    searchShortQuery: 'Digite pelo menos dois caracteres.',
    retry: 'Tentar de novo',
    suggestEmpty: 'Nenhum resultado',
    suggestAll: 'Ver todos os resultados',
    typeSkin: 'Skin',
    typeWeapon: 'Arma',
    typeContainer: 'Caixa',
    typeCollection: 'Coleção',
    catPistols: 'Pistolas',
    catRifles: 'Rifles',
    catSmgs: 'Submetralhadoras',
    catHeavy: 'Armas pesadas',
    catKnives: 'Facas',
    catGloves: 'Luvas',
    catEquipment: 'Equipamento',
    weaponsTitle: 'Armas',
    selectionsTitle: 'Seleções',
    guidesTitle: 'Guias',
    containersTitle: 'Caixas recentes',
    allSkins: 'Todas as skins',
    allGuides: 'Todos os guias',
    allSelections: 'Todas as seleções',
    allCases: 'Todas as caixas',
    allCollections: 'Todas as coleções',
    skinsOne: '{{count}} skin',
    skinsFew: '{{count}} skins',
    skinsMany: '{{count}} skins',
    knivesOne: '{{count}} faca',
    knivesFew: '{{count}} facas',
    knivesMany: '{{count}} facas',
    glovesOne: '{{count}} par de luvas',
    glovesFew: '{{count}} pares de luvas',
    glovesMany: '{{count}} pares de luvas',
    rareItemsOne: '{{count}} item',
    rareItemsFew: '{{count}} itens',
    rareItemsMany: '{{count}} itens',
    skinsPlusRare: '{{skins}} + {{rare}}',
    catalogH1: 'Skins do CS2',
    catalogCategoryH1: 'Skins do CS2: {{category}}',
    filtersTitle: 'Filtros',
    filterWeapon: 'Arma',
    filterRarity: 'Raridade',
    filterCollection: 'Coleção',
    filterCase: 'Caixa',
    filterExterior: 'Desgaste',
    filterStatTrak: 'Tem StatTrak™',
    filterSouvenir: 'Tem versão Lembrança',
    anyWeapon: 'Qualquer arma',
    anyRarity: 'Qualquer raridade',
    anyCollection: 'Qualquer coleção',
    anyCase: 'Qualquer caixa',
    removeFilter: 'Remover filtro “{{name}}”',
    sortLabel: 'Ordenar',
    sortRarity: 'Por raridade',
    sortName: 'Por nome',
    sortRelease: 'Mais novas primeiro',
    sortPrice: 'Por preço',
    applyFilters: 'Mostrar',
    resetFilters: 'Limpar filtros',
    catalogEmptyTitle: 'Nenhuma skin com esses filtros',
    catalogEmptyText: 'Remova alguns filtros ou limpe todos.',
    prevPage: 'Anterior',
    nextPage: 'Próxima',
    pageOf: 'Página {{page}} de {{count}}',
    foundCount: 'Encontradas: {{count}}',
    foundCountMasculine: 'Encontrados: {{count}}',
    priceFrom: 'a partir de {{price}}',
    weaponAllFilters: 'Todos os filtros no catálogo',
    breadcrumbs: 'Trilha de navegação',
    exteriorFn: 'Nova de Fábrica',
    exteriorMw: 'Pouco Usada',
    exteriorFt: 'Testada em Campo',
    exteriorWw: 'Bem Desgastada',
    exteriorBs: 'Veterana de Guerra',
    kindNormal: 'Normal',
    kindStatTrak: 'StatTrak™',
    kindSouvenir: 'Lembrança',
    vanillaFinish: 'Sem pintura',
    phasesTitle: 'Fases',
    statsTitle: 'Características',
    statWeapon: 'Arma',
    statFinish: 'Acabamento',
    statRarity: 'Raridade',
    statFloat: 'Faixa de float',
    statExteriors: 'Desgaste',
    statKinds: 'Versões',
    statCollections: 'Coleção',
    statContainers: 'Caixas',
    statRelease: 'Ano de lançamento',
    rareItem: 'item raro especial',
    rareDropNote: 'Cai como item raro especial ★',
    pricesTitle: 'Preços no Steam',
    pricesHint: 'Preço no Mercado da Comunidade Steam, em dólares americanos.',
    priceAsOf: 'Atualizado em {{date}}.',
    noPrice: 'Sem dados atuais',
    noPriceMarked: 'Sem dados atuais para as versões marcadas',
    gameDescriptionTitle: 'Descrição do jogo',
    faqTitle: 'Perguntas frequentes',
    similarTitle: 'Skins parecidas',
    shotTitle: 'Disponível no SHOT',
    shotHint: 'Esta skin faz parte destas caixas do SHOT.',
    englishName: 'Nome em inglês',
    caseReleased: 'Lançada em {{year}}',
    rareTitle: 'Itens raros especiais',
    compositionTitle: 'Skins incluídas',
    rareHintKnives: 'Facas saem desta caixa como um item raro especial à parte.',
    rareHintGloves: 'Luvas saem desta caixa como um item raro especial à parte.',
    rareHintKnivesAndGloves: 'Facas e luvas saem desta caixa como um item raro especial à parte.',
    rareKnives: 'facas',
    rareGloves: 'luvas',
    rareKnivesAndGloves: 'facas e luvas',
    caseCollectionTitle: 'Coleção da caixa',
    collectionCasesTitle: 'Caixas com esta coleção',
    collectionReleased: 'Lançada em {{year}}',
    tocTitle: 'Sumário',
    reviewedOn: 'Revisado em {{date}}',
    reviewedBy: 'Revisado pela equipe SHOT · {{date}}',
    shortAnswer: 'Resumo',
    guidesH1: 'Guias de skins do CS2',
    selectionsH1: 'Seleções de skins do CS2',
    casesH1: 'Caixas do CS2',
    collectionsH1: 'Coleções do CS2',
    weaponSkinsH1: 'Skins de {{weapon}}',
  },
  tr: {
    wiki: 'Viki',
    homeH1: 'CS2 Skin Vikisi',
    homeSubtitle: 'Tüm CS2 skinleri: aşınma, nadirlik, kasalar ve koleksiyonlar',
    categoriesTitle: 'Kategoriler',
    featuredTitle: 'İncelenen skinler',
    allWeaponsTitle: 'Tüm silahlar',
    aboutWiki: 'Viki hakkında',
    readMore: 'Devamını oku',
    showAll: 'Tümünü göster ({{count}})',
    floatScaleLabel: '0 ile 1 arasındaki float ölçeği ve her aralığın aşınma seviyesi',
    searchPlaceholder: 'Skin, silah veya kasa ara',
    searchPlaceholderShort: 'Skin, silah veya kasa',
    searchSubmit: 'Ara',
    searchClear: 'Aramayı temizle',
    searchH1: 'Vikide ara',
    searchResultsFor: '“{{q}}” için sonuçlar',
    searchEmptyTitle: 'Hiçbir şey bulunamadı',
    searchEmptyText: 'Yazımı kontrol et ya da İngilizce adını dene.',
    searchEmptyTextLatin: 'Yazımı kontrol et ya da aramayı kısalt.',
    searchOpenCatalog: 'Kataloğu aç',
    searchErrorTitle: 'Arama yüklenemedi',
    searchErrorText: 'Bağlantını kontrol edip aramayı tekrarla.',
    searchShortQuery: 'En az iki karakter yaz.',
    retry: 'Tekrar dene',
    suggestEmpty: 'Eşleşme yok',
    suggestAll: 'Tüm sonuçları göster',
    typeSkin: 'Skin',
    typeWeapon: 'Silah',
    typeContainer: 'Kasa',
    typeCollection: 'Koleksiyon',
    catPistols: 'Tabancalar',
    catRifles: 'Tüfekler',
    catSmgs: 'Hafif makineliler',
    catHeavy: 'Ağır silahlar',
    catKnives: 'Bıçaklar',
    catGloves: 'Eldivenler',
    catEquipment: 'Ekipman',
    weaponsTitle: 'Silahlar',
    selectionsTitle: 'Seçkiler',
    guidesTitle: 'Rehberler',
    containersTitle: 'Yeni kasalar',
    allSkins: 'Tüm skinler',
    allGuides: 'Tüm rehberler',
    allSelections: 'Tüm seçkiler',
    allCases: 'Tüm kasalar',
    allCollections: 'Tüm koleksiyonlar',
    skinsOne: '{{count}} skin',
    skinsFew: '{{count}} skin',
    skinsMany: '{{count}} skin',
    knivesOne: '{{count}} bıçak',
    knivesFew: '{{count}} bıçak',
    knivesMany: '{{count}} bıçak',
    glovesOne: '{{count}} çift eldiven',
    glovesFew: '{{count}} çift eldiven',
    glovesMany: '{{count}} çift eldiven',
    rareItemsOne: '{{count}} eşya',
    rareItemsFew: '{{count}} eşya',
    rareItemsMany: '{{count}} eşya',
    skinsPlusRare: '{{skins}} + {{rare}}',
    catalogH1: 'CS2 skinleri',
    catalogCategoryH1: 'CS2 skinleri: {{category}}',
    filtersTitle: 'Filtreler',
    filterWeapon: 'Silah',
    filterRarity: 'Nadirlik',
    filterCollection: 'Koleksiyon',
    filterCase: 'Kasa',
    filterExterior: 'Aşınma',
    filterStatTrak: 'StatTrak™ var',
    filterSouvenir: 'Hatıra sürümü var',
    anyWeapon: 'Tüm silahlar',
    anyRarity: 'Tüm nadirlikler',
    anyCollection: 'Tüm koleksiyonlar',
    anyCase: 'Tüm kasalar',
    removeFilter: '“{{name}}” filtresini kaldır',
    sortLabel: 'Sıralama',
    sortRarity: 'Nadirliğe göre',
    sortName: 'Ada göre',
    sortRelease: 'Önce yeniler',
    sortPrice: 'Fiyata göre',
    applyFilters: 'Göster',
    resetFilters: 'Filtreleri sıfırla',
    catalogEmptyTitle: 'Bu filtrelere uyan skin yok',
    catalogEmptyText: 'Filtrelerin bir kısmını kaldır ya da hepsini sıfırla.',
    prevPage: 'Geri',
    nextPage: 'İleri',
    pageOf: 'Sayfa {{page}} / {{count}}',
    foundCount: 'Bulunan: {{count}}',
    foundCountMasculine: 'Bulunan: {{count}}',
    priceFrom: 'en düşük {{price}}',
    weaponAllFilters: 'Katalogdaki tüm filtreler',
    breadcrumbs: 'Sayfa yolu',
    exteriorFn: 'Fabrikadan Yeni Çıkmış',
    exteriorMw: 'Az Aşınmış',
    exteriorFt: 'Görevde Kullanılmış',
    exteriorWw: 'Eskimiş',
    exteriorBs: 'Savaş Görmüş',
    kindNormal: 'Normal',
    kindStatTrak: 'StatTrak™',
    kindSouvenir: 'Hatıra',
    vanillaFinish: 'Desensiz',
    phasesTitle: 'Fazlar',
    statsTitle: 'Özellikler',
    statWeapon: 'Silah',
    statFinish: 'Kaplama',
    statRarity: 'Nadirlik',
    statFloat: 'Float aralığı',
    statExteriors: 'Aşınma',
    statKinds: 'Sürümler',
    statCollections: 'Koleksiyon',
    statContainers: 'Kasalar',
    statRelease: 'Çıkış yılı',
    rareItem: 'nadir özel eşya',
    rareDropNote: 'Nadir özel eşya olarak düşer ★',
    pricesTitle: 'Steam fiyatları',
    pricesHint: 'Steam Topluluk Pazarı fiyatı, ABD doları olarak.',
    priceAsOf: '{{date}} itibarıyla.',
    noPrice: 'Güncel veri yok',
    noPriceMarked: 'İşaretli sürümler için güncel veri yok',
    gameDescriptionTitle: 'Oyundaki açıklama',
    faqTitle: 'Sık sorulan sorular',
    similarTitle: 'Benzer skinler',
    shotTitle: 'SHOT’ta var',
    shotHint: 'Bu skin şu SHOT kasalarının içeriğinde var.',
    englishName: 'İngilizce adı',
    caseReleased: '{{year}} yılında çıktı',
    rareTitle: 'Nadir özel eşyalar',
    compositionTitle: 'İçerdiği skinler',
    rareHintKnives: 'Bıçaklar bu kasadan ayrı bir nadir özel eşya olarak çıkar.',
    rareHintGloves: 'Eldivenler bu kasadan ayrı bir nadir özel eşya olarak çıkar.',
    rareHintKnivesAndGloves: 'Bıçaklar ve eldivenler bu kasadan ayrı bir nadir özel eşya olarak çıkar.',
    rareKnives: 'bıçaklar',
    rareGloves: 'eldivenler',
    rareKnivesAndGloves: 'bıçaklar ve eldivenler',
    caseCollectionTitle: 'Kasanın koleksiyonu',
    collectionCasesTitle: 'Bu koleksiyonun çıktığı kasalar',
    collectionReleased: '{{year}} yılında çıktı',
    tocTitle: 'İçindekiler',
    reviewedOn: '{{date}} tarihinde kontrol edildi',
    reviewedBy: 'SHOT editörleri kontrol etti · {{date}}',
    shortAnswer: 'Kısaca',
    guidesH1: 'CS2 skin rehberleri',
    selectionsH1: 'CS2 skin seçkileri',
    casesH1: 'CS2 kasaları',
    collectionsH1: 'CS2 koleksiyonları',
    weaponSkinsH1: '{{weapon}} skinleri',
  },
});
